// extracted by mini-css-extract-plugin
var _1 = "B0K7FkZ9SRTrLwnVeQ2B";
export { _1 as "pin" }
